import {useFormik} from 'formik';
import arrow from '../../assets/images/arrow.svg';
import CommonInput from '../../components/CustomeInput';
// import * as yup from 'yup';
import * as Yup from 'yup';
import {API, verifySite} from '../../utils/api';
import {Link, useNavigate} from 'react-router-dom';

import Toast from 'react-bootstrap/Toast';
import {useContext, useEffect, useRef, useState} from 'react';
import Loader from '../../components/Loader';
import {Helmet} from 'react-helmet';
import useRecaptcha from '../../hooks/useRecaptcha';
import axios from 'axios';
import {DataContext} from '../../context/dataContext';

const Sell = () => {
  const [visible, setVisible] = useState(false);
  const [selectedCheckbox, setSelectedCheckbox] = useState('');
  const [lodding, setLoading] = useState(false);
  const [token] = useRecaptcha();
  const navigate = useNavigate();
  const {setClientName} = useContext(DataContext);
  // useEffect(() => {

  //   window?.grecaptcha.ready(() => {
  //     // Execute reCAPTCHA once the library is loaded
  //     window?.grecaptcha
  //       .execute("6LcQ88IpAAAAANAlYuHwl9AcZTXnPoj2AB70p4Cq")
  //       .then((token) => {
  //         // Use the reCAPTCHA token for form submission or further processing
  //         console.log("reCAPTCHA token:", token);
  //         if (token) {
  //           // console.log("token", token);
  //           setToken(token);
  //         }
  //       });
  //   });

  // }, []);

  const handleCheckboxChange = (id) => {
    setSelectedCheckbox(id);
    formik.setFieldValue('checkboxGroup', id);
  };

  const validationSchema = Yup.object().shape({
    registration_number: Yup.string().required(
      'Please enter registration number',
    ),
    // .matches(/^[0-9]+$/, 'Registration number must contain only numbers'),

    // price: Yup.string().required('Please enter price'),
    price: Yup.string()
      .required('Please enter sales price')
      .test('not-multiple-zeroes', 'Offer price cannot be 0', (value) => {
        // Check if the value is not 0 or contains multiple zeroes
        return (
          value !== '0' && !/^0[0-9]*$/.test(value) && !/^0\..*$/.test(value)
        );
      }),

    keywords: Yup.string().notRequired(),

    own_this_number_plate: Yup.boolean().oneOf(
      [true],
      'Please confirm that you own this registration',
    ),
    is_vat_registered: Yup.boolean().oneOf(
      [true, false],
      'Please confirm that you own this registration',
    ),

    first_name: Yup.string()
      .matches(/^[A-Za-z\s]*$/, 'Invalid characters')
      .required('Please enter first name'),

    middle_initials: Yup.string()
      .matches(/^[A-Za-z\s]*$/, 'Only characters')
      .notRequired(),

    last_name: Yup.string()
      .matches(/^[A-Za-z\s]*$/, 'Invalid characters')
      .required('Please enter last name'),

    street_address: Yup.string().required('Please enter street address'),

    town: Yup.string().required('Please enter town'),

    county: Yup.string().notRequired(),
    postcode: Yup.string().required('Please enter postcode '),
    country: Yup.string().required('Please select country'),

    checkboxGroup: Yup.string().test(
      'at-least-one-selected',
      'Please select at least one option',
      (value) => {
        return !!value;
      },
    ),

    email: Yup.string()
      .email('Invalid email')
      .required('Please enter your email.')
      .matches(/@.*\./, 'Domain name is required'),

    submitting: Yup.boolean().oneOf(
      [true],
      'By submitting this form, you are agreeing to REG247’s',
    ),

    // phone_no: Yup.string()
    //   //   .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
    //   .required('Please enter phone number'),

    phone_no: Yup.string()
      .transform((value) => (value ? value.replace(/\s/g, '') : value)) // Remove spaces
      // .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
      .required('Please enter phone number'),

    subscribe: Yup.boolean().notRequired(),
  });

  const formik = useFormik({
    // initialValues: {
    //   reg: '',
    //   price: '',
    //   own_this_number_plate: false,
    //   retention_certificate: false,
    //   vat: false,
    //   contact_permission: false,
    //   firstname: '',
    //   lastname: '',
    //   surname: '',
    //   email: '',
    //   confirm_email: '',
    //   phone: '',
    //   street_address: '',
    //   town: '',
    //   county: '',
    //   postcode: '',
    //   keywords: '',
    // },

    initialValues: {
      registration_number: '',
      price: '',
      keywords: '',
      own_this_number_plate: false,
      is_vat_registered: false,
      first_name: '',
      middle_initials: '',
      last_name: '',
      street_address: '',
      town: '',
      county: '',
      postcode: '',
      country: 'UK',
      email: '',
      phone_no: '',
      subscribe: '',
      checkboxGroup: '',
      submitting: false,
    },
    validationSchema: validationSchema,

    onSubmit: (values) => {
      verifySite(token);
      const {
        registration_number,
        price,
        keywords,
        own_this_number_plate,
        is_vat_registered,
        first_name,
        middle_initials,
        last_name,
        street_address,
        town,
        county,
        postcode,
        country,
        checkboxGroup,
        email,
        phone_no,
        subscribe,
      } = values;
      setLoading(true);

      const body = {
        registrationNumber: registration_number,
        price: price,
        keywords: keywords,
        confirmNumPlat: own_this_number_plate,
        is_vat: is_vat_registered,
        plateHoldingStatus: checkboxGroup,
        firstName: first_name,
        middleInitials: middle_initials,
        lastName: last_name,
        streetAddress: street_address,
        town: town,
        county: county,
        country: country,
        postcode: postcode,
        email: email,
        phone: phone_no,
        contactPermission: subscribe ? true : false,
      };

      console.log('body', body);
      setClientName(first_name + ' ' + last_name);
      try {
        API('sells', 'post', body, '')
          .then((res) => {
            navigate('/thank-you-sell', {
              state: {
                text: "Thanks for your sales request, please look out for an email with how we'll follow up.",
              },
            });
            document.querySelector('body').scrollTo(0, 0);
            setVisible(true);
            setLoading(false);
            formik.resetForm();
            setSelectedCheckbox('');
            console.log('listing added: ', res?.data);
          })
          .catch((e) => console.log('error adding listing: ', e));
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  const navto = (e) => {
    e.preventDefault();
    navigate('/number-plate-valuation');
  };

  const renderToast = () => {
    return (
      <div
        className={`alert alert-success text-start d-flex border-0 align-items-center justify-content-between ${
          visible ? 'visible' : 'hidden'
        }`}>
        <span className="fsi f16">
          Your listing has been submitted successfully, we will notify you soon.
        </span>
        <span
          className="close-btn fs-5"
          role="button"
          onClick={() => setVisible(false)}>
          &#x2715;
        </span>
      </div>
    );
  };
  let nonSpaceEntered = false;
  return (
    <div className="main__page__content ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sell a registration</title>
      </Helmet>
      {lodding && <Loader />}
      <main>
        <div className="reg__enquiry reg__valuation--heading">
          <div className="reg__enquiry--data pt-45 pb-45">
            <div className="container d-flex d-flex_wrap align-center">
              <h2 className="f32 fsi text-white lh45">
                If you are unsure what to advertise your plate for, get a free
                formal valuation instead.
              </h2>
              <div className="fsubmit_btn">
                <button
                  type="submit"
                  className="reg__sell--submit btn text-uppercase f24 lh14 d-flex align-center justify-center"
                  onClick={navto}>
                  FREE VALUATION
                  {/* <img className="in-svg ml-25" src={arrow} alt="Arrow image" /> */}
                  <svg
                    width="36"
                    height="8"
                    viewBox="0 0 36 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="in-svg ml-25">
                    <path
                      d="M35.3536 4.35355C35.5488 4.15829 35.5488 3.84171 35.3536 3.64645L32.1716 0.464466C31.9763 0.269204 31.6597 0.269204 31.4645 0.464466C31.2692 0.659728 31.2692 0.976311 31.4645 1.17157L34.2929 4L31.4645 6.82843C31.2692 7.02369 31.2692 7.34027 31.4645 7.53553C31.6597 7.7308 31.9763 7.7308 32.1716 7.53553L35.3536 4.35355ZM0 4.5H35V3.5H0V4.5Z"
                      fill="black"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <section className="reg__sell--number mt-20">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="reg__sell--data">
                  <div className="reg__sell--title mb-20">
                    <h2 className="f36 fys text-300 mb-5">QUICK LIST</h2>
                    <h1 className="f36 fys text-300">
                      Sell Your Plate For FREE.
                    </h1>
                  </div>
                  {/* <p className="mb-40">
                    Tristique pretium nisi senectus felis scelerisque accumsan
                    at vel. Non velit odio senectus tortor tristique. Elit
                    rhoncus est nibh tortor commodo. Morbi cursus ipsum cursus
                    tempor ut tincidunt eget enim. Facilisis egestas commodo
                    scelerisque interdum sed. Vel nisl eget amet in velit
                    blandit est in aenean. Condimentum dictum tincidunt
                    adipiscing ut. Eu et mi nunc facilisi orci. Tincidunt
                    pretium lorem etiam pellentesque vel et aliquet.
                  </p> */}
                  <p className="mb-40">
                    Selling your plate with REG247 couldn’t be any easier. If
                    you know what price you would like for your plate and want
                    it advertised quickly then complete our simple form and get
                    your plate listed today, completely FREE of charge.
                  </p>
                  {/* <p className="mb-40">
                    Mauris ultrices at malesuada nisi ipsum pellentesque
                    consectetur tempor.
                  </p> */}
                  <p className="mb-40">
                    When completing the form, be sure to add as many key words
                    as possible as this will help buyers find your plate and get
                    it sold even faster!
                  </p>
                  {/* <p className="mb-40">
                    Imperdiet cras curabitur tristique sed eleifend urna.
                    Viverra in viverra malesuada dolor facilisis sed. Sed sit
                    vestibulum id euismod viverra egestas. Ultrices interdum
                    habitasse a lectus nibh molestie donec consequat laoreet.
                    Lacinia in quis nunc velit ut mollis penatibus. Purus amet
                    faucibus faucibus magna senectus consectetur velit.
                  </p> */}
                  <p className="mb-40">
                    There are no fees involved at all when selling your
                    registration, you can advertise your plate today for free.
                    We simply add our commission onto your price when we
                    advertise the plate. Our fees are only payable by the buyer
                    when we sell the plate, so you don’t need to worry about
                    hidden costs!
                  </p>
                  {/* <p className="mb-40">
                    Phasellus malesuada duis est adipiscing pellentesque morbi
                    diam morbi augue. Sem etiam commodo nec hendrerit faucibus
                    in nisl. Maecenas ultricies quam arcu at vestibulum
                    convallis aliquet ultricies. Turpis sit senectus nisl mi
                    malesuada feugiat. Arcu maecenas arcu laoreet cras purus
                    quis volutpat tellus neque. Vulputate risus morbi commodo
                    interdum sem vitae commodo. Cras vel sagittis eget aliquam
                    pretium arcu vel quisque. Ac rhoncus dignissim ac nec
                    rhoncus tempus lorem netus. Augue eros ipsum id arcu. Mattis
                    viverra nisl eget lorem.
                  </p> */}
                  <p className="mb-40">
                    We will handle the whole transfer process for you to make
                    things as simple as possible, we are available to answer any
                    questions you may have and aim to make the sale of your
                    plate a smooth and stress-free transaction.
                  </p>
                  <p className="mb-40">
                    Sell with us today and take advantage of the following
                    benefits:
                  </p>
                  <p className="mb-40">
                    • Reach over 100,000 potential buyers each week.
                    <br /> • No fees involved.
                    <br /> • Seller protection guaranteed. We will never
                    transfer your plate without receiving full payment from the
                    buyer.
                    <br /> • Get paid quickly. We pay our sellers within 1 hour
                    of the transfer completing.
                    <br /> • Add your chosen key words to your listing, making
                    it easier for buyers to search, find and buy your number
                    plate.
                    <br /> • We won’t tie you into a contract to advertise with
                    us.
                    <br /> • Our team will deal with the whole sale process from
                    start to finish. Meaning you can relax, knowing your plate
                    and payment is in safe hands.
                    <br />• We buy number plates for stock. If you are looking
                    for a quick sale, then please give us a call on 01582
                    347734.
                  </p>

                  <img
                    // className="in-svg ml-25"
                    src={require('../../assets/images/sellimg.jpeg')}
                    alt="Arrow image"
                  />
                  {/* <div className="reg__sell--title mb-20">
                    <h5 className="f24 fys text-300">Set Your Own Price</h5>
                  </div>
                  <p className="mb-30">
                    Iaculis justo ac vitae diam. Elit a tempus ultrices blandit
                    egestas morbi id. Fringilla arcu amet cursus proin amet
                    libero elit. Gravida neque enim tortor auctor cras at lacus.{" "}
                  </p>
                  <p className="mb-0">
                    Ullamcorper nulla eget velit pellentesque varius et nunc.
                    Venenatis auctor at et erat leo. Tellus eget purus in vel
                    nulla rutrum varius.
                  </p>
                  <p className="mb-35">
                    Aliquam aliquam sociis tempus nam. Turpis imperdiet egestas
                    mattis eleifend amet id. Proin vitae aliquam sit morbi
                    fames.
                  </p>
                  <div className="reg__sell--title mb-20">
                    <h5 className="f24 fys text-300">Fees</h5>
                  </div>
                  <p className="mb-30">
                    Fermentum vulputate vulputate elementum libero elementum
                    integer. Aliquet fringilla blandit in praesent risus mattis.
                    Id ultricies viverra a posuere at commodo in. Aenean tempus
                    commodo morbi mauris vulputate nibh. Sed diam sit id nibh
                    quam. Libero urna ullamcorper consectetur mollis vel. Ut
                    nunc condimentum vitae non condimentum.
                  </p>
                  <p>
                    Ut est enim cursus consectetur. Tortor nisl egestas eget
                    arcu sagittis libero ac. At morbi risus arcu tellus turpis
                    pretium.
                  </p> */}
                </div>
              </div>
              <div className="col-12 col-lg-6">
                {visible && renderToast()}
                <div className="reg__list--data border rounded-2 p-40">
                  <h5 className="fys text-300 lh32">List Your Reg</h5>
                  {/* <form className="row mt-4 fsi text-400">

                    <CommonInput
                      mainClass="col-12 mb-15"
                      innerClass="input-group bg-image"
                      inputClass="form-control p16 border-0"
                      inputType="text"
                      placeholder="Registration Number"
                      formik={formik}
                      name="reg"
                    />

                    <CommonInput
                      mainClass="col-12 mb-15"
                      innerClass="form__price input-group bg-image"
                      content="£"
                      contentClass="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color"
                      type="number"
                      inputClass="form-control p16 border-0 bg-transparent"
                      formik={formik}
                      name="price"
                      allowOnlyNumbers
                    />
                    <div className="col-12 mb-25">
                      <div className="form-group d-flex">
                        <p className="fsi text-400 mb-0 mr-12">*</p>
                        <p className="fsi text-400 mb-0">
                          Use the search facility on our website to look at the
                          price of similar registrations to yours to get an idea
                          of its value and price to set. You can
                          increase/decrease this amount at any time once listed.
                        </p>
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="form-check mb-8">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="confirm"
                          checked={formik.values.own_this_number_plate}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "own_this_number_plate",
                              e.target.checked
                            )
                          }
                          name="own_this_number_plate"
                        />
                        <label
                          className={
                            formik.touched.own_this_number_plate &&
                            formik.errors.own_this_number_plate
                              ? "form-check-label text-danger"
                              : "form-check-label"
                          }
                          htmlFor="confirm"
                        >
                          I confirm I own this number plate
                        </label>
                      </div>
                      <div className="form-check mb-8">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="Held"
                          checked={formik.values.retention_certificate}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "retention_certificate",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label" htmlFor="Held">
                          Is It Held On Retention Certificate?
                        </label>
                      </div>
                      <div className="form-check mb-8">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="selling"
                          checked={formik.values.vat}
                          onChange={(e) =>
                            formik.setFieldValue("vat", e.target.checked)
                          }
                        />
                        <label className="form-check-label" htmlFor="selling">
                          Are you selling this as a VAT registered business?
                        </label>
                      </div>
                    </div>
            
                    <CommonInput
                      mainClass="col-12 col-md-6 mb-15"
                      innerClass="input-group bg-image"
                      inputClass="form-control p16 border-0"
                      inputType="text"
                      placeholder="First Name"
                      formik={formik}
                      name="firstname"
                    />
        
                    <CommonInput
                      mainClass="col-12 col-md-6 mb-15"
                      innerClass="input-group bg-image"
                      inputClass="form-control p16 border-0"
                      placeholder="Surname"
                      formik={formik}
                      name="surname"
                    />
       
                    <CommonInput
                      mainClass="col-12 col-md-6 mb-15"
                      innerClass="input-group bg-image"
                      inputClass="form-control p16 border-0"
                      placeholder="Email"
                      inputType="text"
                      formik={formik}
                      name="email"
                      allowSpecialCharacters
                    />
      
                    <CommonInput
                      mainClass="col-12 col-md-6 mb-15"
                      innerClass="input-group bg-image"
                      inputClass="form-control p16 border-0"
                      placeholder="Confirm Email"
                      inputType="text"
                      formik={formik}
                      name="confirm_email"
                      allowSpecialCharacters
                    />
  
                    <CommonInput
                      mainClass="col-12 col-md-6 mb-15"
                      innerClass="input-group bg-image fnumber"
                      content="+44"
                      contentClass="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color"
                      inputClass="form-control p16 border-0"
                      placeholder="Phone"
                      inputType="text"
                      formik={formik}
                      name="phone"
                      allowOnlyNumbers
                    />

                    <CommonInput
                      mainClass="col-12 mb-15"
                      innerClass="form__price input-group bg-image"
                      inputClass="form-control p16 border-0"
                      placeholder="Street Address"
                      formik={formik}
                      name="street_address"
                      allowSpecialCharacters
                    />

                    <CommonInput
                      mainClass="col-12 col-md-4 mb-15"
                      innerClass="form__price input-group bg-image"
                      inputClass="form-control p16 border-0"
                      inputType="text"
                      placeholder="Town"
                      formik={formik}
                      name="town"
                      allowSpecialCharacters
                    />
  
                    <CommonInput
                      mainClass="col-12 col-md-4 mb-15"
                      innerClass="form__price input-group bg-image"
                      inputClass="form-control p16 border-0"
                      inputType="text"
                      placeholder="County"
                      formik={formik}
                      name="county"
                      allowSpecialCharacters
                    />
          
                    <CommonInput
                      mainClass="col-12 col-md-4 mb-15"
                      innerClass="form__price input-group bg-image"
                      inputClass="form-control p16 border-0"
                      inputType="text"
                      placeholder="Postcode"
                      formik={formik}
                      name="postcode"
                    />
                    <p className="f20 text-400 lh28 mb-15">
                      Contact Permission
                    </p>
                    <p className="text-400 lh24 mb-15">
                      We'd love to send you exclusive offers, new and
                      information about our services by email.
                    </p>
                    <div className="col-12 mb-15">
                      <div className="form-check mb-8">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="unsuscribe"
                          checked={formik.values.contact_permission}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "contact_permission",
                              e.target.checked
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="unsuscribe"
                        >
                          Yes please, i'd like to hear about offers and
                          services. You can unsubscribe at any time.
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mb-15">
                      <div className="form-check fsubmit_btn mb-0">
                        <button
                          type="button"
                          className="reg__sell--submit btn text-uppercase f24 lh14 d-flex align-center justify-center"
                          onClick={formik.handleSubmit}
                        >
                          Submit listing{" "}
                          <img
                            className="in-svg ml-25"
                            src={arrow}
                            alt="Arrow image"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="form_tearm">
                      <span className="fsi text-400 lh20">
                        This site is protected by reCAPTCHA and the Google{" "}
                        <a href="#" className="f-14">
                          <u>Privacy Policy</u>
                        </a>{" "}
                        and{" "}
                        <a href="#" className="f-14">
                          <u>Terms of Service</u>
                        </a>{" "}
                        apply.
                      </span>
                    </div>
            
                  </form> */}
                  <form
                    className="row mt-4 fsi text-400"
                    onSubmit={formik.handleSubmit}>
                    {/* Registration Number */}
                    <div className="col-12 col-md-6 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Registration Number
                        <span className="reg__iimportant f24"> *</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputEmail4"
                          placeholder="Registration Number"
                          value={formik.values.registration_number}
                          onChange={(e) => {
                            const inputValue = e.target.value
                              ?.trimStart()
                              .slice(0, 8)
                              .toUpperCase(); // Limit input to 11 characters
                            formik.setFieldValue(
                              'registration_number',
                              inputValue,
                            );
                          }}
                        />
                      </div>
                      {formik.touched.registration_number &&
                        formik.errors.registration_number && (
                          <div className="text-danger">
                            {formik.errors.registration_number}
                          </div>
                        )}
                    </div>
                    <div className="col-12 col-md-6 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Price<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image fnumber">
                        <div className="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color">
                          £
                        </div>
                        <input
                          type="number"
                          className="form-control p16 border-0"
                          min={0}
                          id="inputCity"
                          placeholder="Price"
                          value={formik.values.price}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'price',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.price && formik.errors.price && (
                        <div className="text-danger">{formik.errors.price}</div>
                      )}
                    </div>
                    <div className="col-12 mb-20">
                      <label className="f16 mb-10" htmlFor="">
                        Keywords
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputEmail4"
                          placeholder="e.g. Kate, Katie, Katy, Kat, Katherine"
                          value={formik.values.keywords}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'keywords',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-0">
                      <div className="form-group">
                        <p className="fsi text-400 mb-0">
                          Help buyers to find your plate by adding up to 5
                          keywords, Get your plate seen and sold even quicker!
                        </p>
                      </div>
                      <div className="reg__data--check-label">
                        <div className="form-check mb-20">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="confirm"
                            name="listdata1"
                            checked={formik.values.own_this_number_plate}
                            onChange={(e) =>
                              formik.setFieldValue(
                                'own_this_number_plate',
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className={
                              formik.touched.own_this_number_plate &&
                              formik.errors.own_this_number_plate
                                ? 'form-check-label text-danger'
                                : 'form-check-label'
                            }
                            htmlFor="confirm">
                            I confirm I own this number plate
                            <span className="reg__iimportant f24">*</span>
                          </label>
                        </div>

                        <div className="form-group mb-15">
                          <p className="fsi text-400 mb-0">
                            How is the number plate currently held? Select
                            below:<span className="reg__iimportant f24">*</span>
                          </p>
                        </div>

                        <div className="col-12 mb-15 d-flex flex-wrap">
                          <div className="form-check mb-8 col-12 col-xxl-5">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="certificate"
                              name="listdata"
                              checked={selectedCheckbox === 'retention'}
                              onChange={() => handleCheckboxChange('retention')}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="certificate">
                              It's held on a retention certificate
                            </label>
                          </div>
                          <div className="form-check mb-8 col-12 col-xxl-7">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="assigned"
                              name="listdata"
                              checked={selectedCheckbox === 'assigned'}
                              onChange={() => handleCheckboxChange('assigned')}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="assigned">
                              It's currently assigned to a vehicle
                            </label>
                          </div>
                          {/* <div className="form-check mb-8 col-12">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="selling"
                              name="listdata"
                              checked={selectedCheckbox === "selling"}
                              onChange={() => handleCheckboxChange("selling")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="selling"
                            >
                              I am selling this number plate through a VAT
                              registered company
                            </label>
                          </div> */}
                          {formik.touched.checkboxGroup &&
                            formik.errors.checkboxGroup && (
                              <div className="text-danger">
                                {formik.errors.checkboxGroup}
                              </div>
                            )}
                        </div>

                        <div className="form-check mb-20">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="confirm2"
                            name="listdata1"
                            checked={formik.values.is_vat_registered}
                            onChange={(e) =>
                              formik.setFieldValue(
                                'is_vat_registered',
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className={
                              formik.touched.is_vat_registered &&
                              formik.errors.is_vat_registered
                                ? 'form-check-label text-danger'
                                : 'form-check-label'
                            }
                            htmlFor="confirm2">
                            I am selling this number plate through a VAT
                            registered company
                            {/* <span className="reg__iimportant f24">*</span> */}
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* First Name */}
                    <div className="col-12 col-md-4 mb-30 flex-grow-1 flex-shrink-1">
                      <label className="f16 mb-10" htmlFor="">
                        First Name<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="First Name"
                          value={formik.values.first_name}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'first_name',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.first_name &&
                        formik.errors.first_name && (
                          <div className="text-danger">
                            {formik.errors.first_name}
                          </div>
                        )}
                    </div>
                    {/* Surname */}
                    <div className="col-12 col-sm-5 col-md-3 mb-30 reg__middle--name">
                      <label className="f16 mb-10" htmlFor="">
                        Middle Initials
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="Initial"
                          value={formik.values.middle_initials}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'middle_initials',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.middle_initials &&
                        formik.errors.middle_initials && (
                          <div className="text-danger">
                            {formik.errors.middle_initials}
                          </div>
                        )}
                    </div>
                    {/* Last Name */}
                    <div className="col-12 col-sm-7 col-md-4 mb-30 flex-grow-1 flex-shrink-1">
                      <label className="f16 mb-10" htmlFor="">
                        Last Name<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="Last Name"
                          value={formik.values.last_name}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'last_name',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.last_name && formik.errors.last_name && (
                        <div className="text-danger">
                          {formik.errors.last_name}
                        </div>
                      )}
                    </div>
                    {/* Address */}
                    <div className="col-12 mb-15">
                      <label className="f16 mb-10" htmlFor="">
                        Street Address
                        <span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="Street Address"
                          value={formik.values.street_address}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'street_address',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.street_address &&
                        formik.errors.street_address && (
                          <div className="text-danger">
                            {formik.errors.street_address}
                          </div>
                        )}
                    </div>
                    {/* Town */}
                    <div className="col-6 mb-15 reg__town--fild">
                      <label className="f16 mb-10" htmlFor="">
                        Town<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="Town"
                          value={formik.values.town}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'town',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.town && formik.errors.town && (
                        <div className="text-danger">{formik.errors.town}</div>
                      )}
                    </div>
                    {/* County */}
                    <div className="col-6 mb-15 reg__county--fild">
                      <label className="f16 mb-10" htmlFor="">
                        County
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="County"
                          value={formik.values.county}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'county',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.county && formik.errors.county && (
                        <div className="text-danger">
                          {formik.errors.county}
                        </div>
                      )}
                    </div>
                    {/* Postcode */}
                    <div className="col-6 mb-15 reg__postcode--fild">
                      <label className="f16 mb-10" htmlFor="">
                        Postcode<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id=""
                          placeholder="Postcode"
                          value={formik.values.postcode}
                          onChange={(e) => {
                            const newValue = e.target.value.replace(
                              /[^a-zA-Z0-9]/g,
                              '',
                            ); // Remove non-alphanumeric characters
                            formik.setFieldValue('postcode', newValue);
                          }}
                        />
                      </div>
                      {formik.touched.postcode && formik.errors.postcode && (
                        <div className="text-danger">
                          {formik.errors.postcode}
                        </div>
                      )}
                    </div>
                    {/* Country */}
                    <div className="col-6 mb-15 reg__country--fild">
                      <label className="f16 mb-10" htmlFor="">
                        Country<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <select
                          name=""
                          id=""
                          className="form-control p16 position-static border-0">
                          <option value="">UK</option>
                        </select>
                      </div>
                    </div>
                    {/* Email */}
                    <div className="col-12 col-md-6 mb-35">
                      <label className="f16 mb-10" htmlFor="">
                        Email<span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image">
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputCity"
                          placeholder="example@mail.com"
                          value={formik.values.email}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'email',
                              e.target.value?.trimStart(),
                            );
                          }}
                        />
                      </div>
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </div>
                    {/* Phone */}
                    <div className="col-12 col-md-6 mb-35">
                      <label className="f16 mb-10" htmlFor="">
                        Phone
                        <span className="reg__iimportant f24">*</span>
                      </label>
                      <div className="input-group bg-image fnumber">
                        {/* <div className="input-group-text border-0 rounded-0 bg-transparent p15 green-image border-end br-2 border-color">
                          +44
                        </div> */}
                        <input
                          type="text"
                          className="form-control p16 border-0"
                          id="inputCity"
                          placeholder="Phone"
                          value={formik.values.phone_no}
                          // onChange={(e) => {
                          //   const inputValue = e.target.value
                          //     ?.trimStart()
                          //     .slice(0, 10);
                          //   formik.setFieldValue('phone_no', inputValue);
                          // }}
                          onChange={(e) => {
                            let input = e.target.value;
                            const regex = /^[0-9\s]*$/; // Regular expression to allow only numbers and spaces
                            if (!nonSpaceEntered) {
                              // If no non-space character entered yet, trim spaces
                              input = input.trimStart();
                            }
                            if (regex.test(input) || input === '') {
                              formik.setFieldValue('phone_no', input);
                              // Check if a non-space character has been entered
                              if (input !== '' && !nonSpaceEntered) {
                                nonSpaceEntered = true;
                              }
                            }
                          }}
                        />
                      </div>
                      {formik.touched.phone_no && formik.errors.phone_no && (
                        <div className="text-danger">
                          {formik.errors.phone_no}
                        </div>
                      )}
                    </div>
                    {/* <p className="f20 text-400 lh28 mb-15">
                      Contact Permission
                    </p>
                    <p className="text-400 lh24 mb-15">
                      We'd love to send you exclusive offers, new and
                      information about our services by email.
                    </p> */}

                    <div className="col-12">
                      <div
                        className="form-check mb-20 reg__confirm--box"
                        style={{alignItems: 'center'}}>
                        <input
                          id="unsubscribe1"
                          className="form-check-input"
                          type="checkbox"
                          checked={formik.values.submitting}
                          onChange={(e) =>
                            formik.setFieldValue('submitting', e.target.checked)
                          }
                        />
                        <label
                          className={
                            formik.touched.submitting &&
                            formik.errors.submitting
                              ? 'form-check-label text-danger f16'
                              : 'form-check-label f16'
                          }
                          htmlFor="unsubscribe1">
                          By submitting this form, you are agreeing to REG247’s{' '}
                          <Link
                            to="/privacy-policy"
                            className="privacy-link"
                            rel="noopener"
                            rel="noreferrer"
                            target="_blank">
                            <span
                              // className="f16"
                              className={
                                formik.touched.submitting &&
                                formik.errors.submitting
                                  ? 'form-check-label text-danger f16'
                                  : 'form-check-label f16'
                              }
                              style={{textDecorationLine: 'underline'}}>
                              privacy policy
                            </span>
                          </Link>
                          <span className="f24">*</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-12 mb-15">
                      <div className="form-check mb-8 reg__confirm--box">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="unsuscribe"
                          checked={formik.values.subscribe}
                          onChange={(e) =>
                            formik.setFieldValue('subscribe', e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label f16"
                          htmlFor="unsuscribe">
                          Subscribe for special offers, discounts and number
                          plates that may be relevant to me. I understand that I
                          can unsubscribe at any time.
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mb-15">
                      <div className="form-check fsubmit_btn mb-0">
                        <button
                          type="submit"
                          className="reg__sell--submit btn text-uppercase f24 lh14 d-flex align-center justify-center">
                          Submit FREE Listing{' '}
                          <img
                            className="in-svg ml-25"
                            src={arrow}
                            alt="Arrow image"
                          />
                        </button>
                      </div>
                    </div>
                    {/* <div className="form_tearm">
                      <span className="fsi text-400 lh20">
                        This site is protected by reCAPTCHA and the Google{' '}
                        <Link to={'/privacy-policy'} className="f-14">
                          <u>Privacy Policy</u>
                        </Link>{' '}
                        and{' '}
                        <Link to={'/terms-and-conditions'} className="f-14">
                          <u>Terms of Service</u>
                        </Link>{' '}
                        apply.
                      </span>
                    </div> */}
                    {/* </div> */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};
export default Sell;
